var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ScaleResultsSectionsListComponent } from '../scale-results-sections-list/scale-results-sections-list.component';
var AddoScaleResultsComponent = /** @class */ (function (_super) {
    __extends(AddoScaleResultsComponent, _super);
    function AddoScaleResultsComponent() {
        var _this = _super.call(this) || this;
        _this._pageBreaks = [];
        _this._skipTable = false;
        _this._skipContent = false;
        _this._skipGraph = false;
        return _this;
    }
    AddoScaleResultsComponent.prototype.ngOnInit = function () {
    };
    AddoScaleResultsComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    Object.defineProperty(AddoScaleResultsComponent.prototype, "SkipContent", {
        get: function () {
            return this._skipContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddoScaleResultsComponent.prototype, "SkipGraph", {
        get: function () {
            return this._skipGraph;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddoScaleResultsComponent.prototype, "SkipTable", {
        get: function () {
            return this._skipTable;
        },
        enumerable: true,
        configurable: true
    });
    AddoScaleResultsComponent.prototype.getHTMLClassNames = function () {
        return ["scale-results", "report-item-component", "flex-column"];
    };
    AddoScaleResultsComponent.prototype.setReportData = function (data, results, variables) {
        _super.prototype.setReportData.call(this, data, results, variables);
        if (data && data.scales_per_page) {
            this._scales_per_page = +data.scales_per_page;
        }
        else if (this.ScaleResults) {
            // this makes it so we never force a page break here.
            this._scales_per_page = this.ScaleResults.length + 1;
        }
        else {
            console.error("No scales found for component");
            this._scales_per_page = 0;
        }
        if (data.pageBreaks && data.pageBreaks.length > 0) {
            this._pageBreaks = data.pageBreaks.map(function (pb) { return +pb; }).filter(function (pb) { return !isNaN(pb); });
        }
        else {
            this._pageBreaks = [];
        }
        if (data) {
            this._skipTable = data.skipTable == true;
            this._skipGraph = data.skipGraph == true;
            this._skipContent = data.skipContent == true;
        }
    };
    // shouldPrintBreak(0), showPageHeader(0), scales_per_page = 2
    // index=0: false, false -> should be false, false
    // index=1: true, true  -> should be true, false
    // index=2: false, false -> should be false, true
    // shouldPrintBreak(0), showPageHeader(0), scales_per_page = 2, scales_per_page=3
    // index=0: false, false => should be false, false
    // index=1: false, false => should be false, false
    // index=2: true, true, should be true, false
    // index=3: false, false -> should be false, true
    AddoScaleResultsComponent.prototype.showPageHeader = function (index) {
        if (index == 0) {
            return false;
        }
        if (this._pageBreaks && this._pageBreaks.length > 0) {
            return this._pageBreaks.indexOf(index) >= 0;
        }
        // since index is 0 based the the user scales per page is 1 based we convert.
        var pageBreakIndex = (index + 1) - this._scales_per_page;
        if (index < 0) {
            return false;
        }
        else if (index % this._scales_per_page == 0) {
            return true;
        }
        else {
            return false;
        }
    };
    Object.defineProperty(AddoScaleResultsComponent.prototype, "ScalesPerPage", {
        get: function () {
            return this._scales_per_page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddoScaleResultsComponent.prototype, "IsSingleScaleResult", {
        get: function () {
            var isSingle = this.ScaleResults && this.ScaleResults.length == 1;
            return isSingle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddoScaleResultsComponent.prototype, "SingleScaleResult", {
        get: function () {
            if (this.ScaleResults && this.ScaleResults[0]) {
                return this.ScaleResults[0];
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    return AddoScaleResultsComponent;
}(ScaleResultsSectionsListComponent));
export { AddoScaleResultsComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/addo-scale-results/addo-scale-results.component.ts.pre-build-optimizer.js